import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import * as utils from './utils'
import ability from './ability'

export const useUtils = () => ({
  ...utils,
})

export const _ = null

Vue.use(abilitiesPlugin, ability)
